module.exports = __webpack_public_path__ + "img/20f3.ea607e54.jpg";